<nz-space class="mobile-report-control">
    <app-pr-select [(ngModel)]="from" class="report-control" (ngModelChange)="fromChange.emit($event)"
      valueField="docCode">
    </app-pr-select>
    <span class="text-center">
      <span nz-icon nzType="swap-right" nzTheme="outline"></span>
    </span>
    <app-pr-select [(ngModel)]="to" class="report-control" (ngModelChange)="toChange.emit($event)" valueField="docCode">
    </app-pr-select>
</nz-space>
  